import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type HangupCallRequest = void;

export interface HangupCallRepository {
  removeCalls(): Promise<void>;
  fetchTransferCall(): Promise<Call>;
}

export interface HangupCallEventPublisher {
  publish(): Promise<void>;
}

export interface HangupCallUsecase
  extends BaseUsecase<HangupCallRequest, void> {
  run(call: HangupCallRequest): Promise<void>;
}

export class HangupCall implements HangupCallUsecase {
  constructor(
    private repository: HangupCallRepository,
    private publisher: HangupCallEventPublisher,
  ) {}

  async run(): Promise<void> {
    const transferCall = await this.repository.fetchTransferCall();
    await this.publisher.publish();
    if (transferCall) {
      setTimeout(async () => {
        await this.publisher.publish();
      }, 6000);
    }
    await this.repository.removeCalls();
  }
}
